module.exports = __webpack_public_path__ + "static/media/financecase4.f4faff00.png";